import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KeyValueSortPipe } from './key-value-sorted.pipe';
import { XlsxLineErrorPipe } from './xlsx-line-error.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [XlsxLineErrorPipe, KeyValueSortPipe],
    exports: [XlsxLineErrorPipe, KeyValueSortPipe],
})
export class PipesSharedModule {}
